import { render, staticRenderFns } from "./SancionesAdministrativas.vue?vue&type=template&id=6bf51d91"
import script from "./SancionesAdministrativas.vue?vue&type=script&lang=js"
export * from "./SancionesAdministrativas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports